import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Icon, message, notification } from 'antd';
import Btn from '../../../../../../components/btn';
import { useFormMethods } from '../../../../../../helpers/formManager';
import { actionCreators, sliceKeys } from '../../../../model';
import { useAcceptanceViewInfoInvalidate } from '../../../../api/acceptanceViewInfo';
import { mapDesksSettingsValuesToPayload } from '../../../../services/acceptancePayloadMapper';
import { useDesksConfigs } from '../../services/desksConfigs';
import { useChangeDesksSettingsMutation } from '../../../../api/changeDesksSetings';
import { useAcceptanceViewFlatsInvalidate } from '../../../../api/acceptanceViewFlats';
import { useAcceptanceViewCalendarInvalidate } from '../../../../api/acceptanceViewCalendar';

const { changeDesksSettingsPageReset } =
  actionCreators[sliceKeys.changeDesksSettingsPage];

const SaveChanges = () => {
  const history = useHistory();

  const { handleSubmit } = useFormMethods();

  const dispatch = useDispatch();

  const invalidateViewInfo = useAcceptanceViewInfoInvalidate();
  const invalidateFlatsView = useAcceptanceViewFlatsInvalidate();
  const invalidateCalendarView = useAcceptanceViewCalendarInvalidate();

  const {
    mutate: changeDesksSettings,
    isLoading: isChangeDesksSettingsLoading,
  } = useChangeDesksSettingsMutation({
    onSuccess: (data) => {
      if (data.success === false) {
        message.error(
          data.message || 'Не удалось изменить настройку работы столов'
        );
        return;
      }

      const { push, location } = history;

      push(location.state.from.location);

      invalidateViewInfo();
      invalidateFlatsView();
      invalidateCalendarView();

      dispatch(changeDesksSettingsPageReset());
    },
  });

  const configs = useDesksConfigs();

  const onSubmit = (values) => {
    if (!configs.hasChanged(values)) {
      notification.error({ message: 'Данные не изменены' });
      return;
    }

    const payload = mapDesksSettingsValuesToPayload(values);

    changeDesksSettings({
      acceptanceId: history.location.state.from.acceptance.id,
      payload,
    });
  };

  return (
    <Btn
      onClick={handleSubmit(onSubmit)}
      disabled={isChangeDesksSettingsLoading}
    >
      <span>Сохранить</span>
      <Icon
        type={isChangeDesksSettingsLoading ? 'loading' : 'check'}
        style={{ height: '14px' }}
      />
    </Btn>
  );
};

export default SaveChanges;
